var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"content non-existing-site"},[_c('div',{staticClass:"vertical-middle min-vh-100"},[_c('div',{staticClass:"heading-block center nobottomborder"},[_c('h1',[_vm._v(_vm._s(_vm.$t('non-existing-site.title')))])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }